import { mediumBreakpoint, mobileBreakpoint, tabletBreakpoint, TxtColor } from "shared/theme/defaultTheme";
import { makeSharedStyles } from "shared/theme/makeSharedStyles";

export const useMenuProfileStyles = makeSharedStyles(theme => ({
    root: {
        padding: theme.spacing(0, 3, 3),

        [theme.breakpoints.down(tabletBreakpoint)]: {
            padding: 0,
        },
    },

    heading: {
        maxWidth: "120px",
        lineHeight: "1.4rem",
        wordWrap: "break-word",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    roleOrAcoountTypeTypography: {
        color: TxtColor.Txt2,
    },

    profileContainer: {
        width: "auto",
        [theme.breakpoints.down(mobileBreakpoint)]: {
            marginLeft: theme.spacing(2),
        },
    },

    subMenuIconContainer: {
        position: "relative",
    },

    toggleMobilePopperIcon: {
        marginLeft: theme.spacing(2),
        alignSelf: "flex-start",
        marginTop: theme.spacing(),
        [theme.breakpoints.up(mediumBreakpoint)]: {
            marginTop: 0,
            marginLeft: 0,
        },
    },

    subMenuIcon: {
        padding: theme.spacing(1),
        marginLeft: theme.spacing(2),
        "&:not(:hover)": {
            color: TxtColor.Txt4,
        },
        [theme.breakpoints.up(mediumBreakpoint)]: {
            marginLeft: 0,
        },
        [theme.breakpoints.down(tabletBreakpoint)]: {
            padding: 0,
            marginLeft: 0,
        },
    },
}));

export const usePopupStyles = makeSharedStyles(theme => ({
    list: {
        zIndex: theme.zIndex.modal,
    },
    paper: {
        padding: 0,
        border: `1px solid ${TxtColor.Txt6}`,
        borderRadius: "8px",
    },
}));
